import React, { useState } from "react";
import cn from "classnames";
import styles from "./PasswordInput.module.sass";
import Icon from "../Icon";
import Tooltip from "../Tooltip";

const PasswordInput = ({
  className,
  classLabel,
  classInput,
  label,
  icon,
  tooltip,
  place,
  required,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className={cn(
        styles.field,
        { [styles.fieldIcon]: icon },
        { [styles.fieldPassword]: true },
        className
      )}
    >
      {label && (
        <div className={cn(classLabel, styles.label)}>
          {label}{required && <span className={styles.required}> *</span>}{" "}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place={place ? place : "right"}
            />
          )}
        </div>
      )}
      <div className={styles.wrap}>
        <input 
          className={cn(classInput, styles.input)} 
          type={showPassword ? "text" : "password"}
          {...props} 
        />
        {icon && (
          <div className={styles.icon}>
            <Icon name={icon} size="24" />
          </div>
        )}
        <button 
          type="button"
          className={styles.togglePassword}
          onClick={togglePasswordVisibility}
          title={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        >
          <Icon name={showPassword ? "eye-off" : "eye"} size="20" />
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
